import React from 'react'
import { Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap'

const InfoPage = React.createClass({
  getInitialState: function () {
    return {
      info: this.props.location.state.info,
      newPasswordText: '',
      newPasswordConfirmText: ''
    }
  },
  componentDidMount: function () {
    this.setState({
      info: this.props.location.state.info,
      newPasswordText: '',
      newPasswordConfirmText: ''
    })
  },
  doPasswordsMatch: function () {
    let passwordConfirmation = this.state.newPasswordConfirmText
    let newPassword = this.state.newPasswordText
    let vsState = null
    if (newPassword && passwordConfirmation) {
      if (newPassword.length > 0 && passwordConfirmation.length > 0) {
        if (newPassword === passwordConfirmation) {
          vsState = 'success'
        } else {
          vsState = 'error'
        }
      }
    }
    return vsState
  },
  handleChangeConfirmPassword: function (event) {
    this.setState({
      newPasswordConfirmText: event.target.value
    })
  },
  handleChangeNewPassword: function (event) {
    this.setState({
      newPasswordText: event.target.value
    })
  },
  isNewPasswordValid: function () {
    if (this.state.newPasswordText && this.state.newPasswordText !== '') {
      let newPassword = this.state.newPasswordText
      if (newPassword.length > 10) return 'success'
      else if (newPassword.length > 5) return 'warning'
      else if (newPassword.length > 0) return 'error'
    }
    return null
  },
  propTypes: {
    location: React.PropTypes.object
  },
  render: function () {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    return (
      <div className='center-block row'>
        <div className='col-xs-1' />
        <div className='col-xs-10'>
          <h2 className='text-center'><b>Update Account Info</b></h2>
          <br />
          <form>
            <FormGroup bsClass='form-group has-value' controlId='updateUserName'>
              <ControlLabel>Name</ControlLabel>
              <FormControl ref='updateUserName' defaultValue={this.props.location.state.name} type='text' onChange={this.toggleHasValue} />
            </FormGroup>
            <FormGroup bsClass='form-group has-value' controlId='updateUserEmail'>
              <ControlLabel>Email</ControlLabel>
              <FormControl ref='updateUserEmail' defaultValue={this.props.location.state.email} type='text' onChange={this.toggleHasValue} />
            </FormGroup>
            <FormGroup bsClass='form-group has-value' controlId='updateUserCell'>
              <ControlLabel>Cell Number</ControlLabel>
              <FormControl ref='updateUserCell' defaultValue={this.props.location.state.phone} type='text' onChange={this.toggleHasValue} />
            </FormGroup>
            <FormGroup controlId='updateUserPassword' validationState={this.isNewPasswordValid()}>
              <ControlLabel>New Password</ControlLabel>
              <FormControl defaultValue='' type='password' onBlur={this.handleChangeNewPassword} onChange={this.toggleHasValue} />
            </FormGroup>
            <FormGroup controlId='updateUserPasswordConfirm' validationState={this.doPasswordsMatch()} >
              <ControlLabel>Confirm Password</ControlLabel>
              <FormControl defaultValue='' type='password' onBlur={this.handleChangeConfirmPassword} onChange={this.toggleHasValue} />
              <FormControl.Feedback />
            </FormGroup>
            <FormGroup>
              <Button type='submit' bsClass='btn btn-info btn-sm center-block'>
                Submit
              </Button>
            </FormGroup>
          </form>
          <div className='pull-down-xs-2' />
        </div>
        <div className='col-xs-1' />
      </div>
    )
  }
})

export default InfoPage



// WEBPACK FOOTER //
// ./src/components/account/info-page.jsx